import { createSelector } from 'reselect';
import { getLanguage, getStateSlice } from './selectors';

function translate(language, temperatureUnit) {
  const translations = temperatureUnit.get('info').get(language);
  const code = temperatureUnit.get('code');
  if (!translations) {
    throw new Error(
      `No translations available for temperatures unit of measure '${code}' with language '${language}'`
    );
  }
  return {
    code,
    name: translations.get('text'),
    shortName: translations.get('textShort'),
    slug: translations.get('slug')
  };
}

const getTemperatureUnitMap = state =>
  getStateSlice(state).get('temperatureUnits');

const getMarketTemperatureUnitMap = state =>
  getStateSlice(state).get('marketTemperatureUnits');

export const getTemperatureUnits = createSelector(
  getTemperatureUnitMap,
  temperatureUnitMap => temperatureUnitMap.toList()
);

export const getMarketTemperatureUnits = createSelector(
  getMarketTemperatureUnitMap,
  temperatureUnitMap => temperatureUnitMap.toList()
);

export const getTemperatureUnitTranslated = code =>
  createSelector(
    getLanguage,
    getTemperatureUnitMap,
    (language, temperatureUnitMap) => {
      if (!code) {
        return null;
      }
      const temperatureUnit = temperatureUnitMap.get(code);
      return translate(language, temperatureUnit);
    }
  );
